// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const DuoSocketUK = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    /*eslint-disable max-len */
    return (
        <G {...gProps}>
            <Path d="M34.18,31.05H5.82A1.82,1.82,0,0,1,4,29.23V10.77A1.82,1.82,0,0,1,5.82,8.95H34.18A1.82,1.82,0,0,1,36,10.77V29.23A1.82,1.82,0,0,1,34.18,31.05ZM5.82,9.95a.82.82,0,0,0-.82.82V29.23a.82.82,0,0,0,.82.82H34.18a.82.82,0,0,0,.82-.82V10.77a.82.82,0,0,0-.82-.82Z" />
            <Path d="M27.31,16.35c-.22,0-.81.18-.81.41v2.84c0,.22.59.41.81.41s.81-.18.81-.41V16.75C28.12,16.53,27.53,16.35,27.31,16.35Z" />
            <Path d="M25.68,22.84c0-.22-.14-.81-.32-.81H23.16c-.17,0-.32.59-.32.81s.14.81.32.81h2.21C25.54,23.65,25.68,23.07,25.68,22.84Z" />
            <Path d="M31.77,22.84c0-.22-.14-.81-.32-.81H29.25c-.17,0-.32.59-.32.81s.14.81.32.81h2.21C31.63,23.65,31.77,23.07,31.77,22.84Z" />
            <Path d="M12.69,16.35c-.22,0-.81.18-.81.41v2.84c0,.22.59.41.81.41s.81-.18.81-.41V16.75C13.51,16.53,12.92,16.35,12.69,16.35Z" />
            <Path d="M11.07,22.84c0-.22-.14-.81-.32-.81H8.54c-.17,0-.32.59-.32.81s.14.81.32.81h2.21C10.93,23.65,11.07,23.07,11.07,22.84Z" />
            <Path d="M17.16,22.84c0-.22-.14-.81-.32-.81H14.63c-.17,0-.32.59-.32.81s.14.81.32.81h2.21C17,23.65,17.16,23.07,17.16,22.84Z" />
        </G>
    );
    /*eslint-enable max-len */
};

export default DuoSocketUK;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/devices/duo-socket-uk/index.js